import * as React from "react";
import {Icon} from "./Icon";

export class LinkIcon extends Icon {

  render() {
    return <Icon {...this.props}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<polygon points="17.17 26.94 14.83 25.06 22.08 16 14.83 6.94 17.17 5.06 25.92 16 17.17 26.94" />
					<polygon points="9.17 26.94 6.83 25.06 14.08 16 6.83 6.94 9.17 5.06 17.92 16 9.17 26.94" />
        </svg>
      </Icon>;
  }
}
